@if (!isMobileView) {
  <div class="container-margin">
    <div class="row">
      <span class="bold xx-large-font">{{
        translationService.getComponentsText()
      }}</span>
    </div>
    <div class="margin-top-40">
      <mat-divider></mat-divider>
    </div>
    <app-chemistry-nav
      (selectedProductChange)="setProductChemistry($event)"
    ></app-chemistry-nav>

    <app-chemistry-info
      [chemistry]="productChemistry"
      [isMobileView]="isMobileView"
    ></app-chemistry-info>
    @if (productChemistry?.substances && productChemistry?.substances?.length) {
      <div class="margin-top-40">
        <mat-divider></mat-divider>
      </div>
      <!--      @for (-->
      <!--        elementOfConcern of productChemistry!.substances;-->
      <!--        track elementOfConcern-->
      <!--      ) {-->
      <!--        <div class="margin-top-40">-->
      <!--          <app-element-of-concern-->
      <!--            [elementOfConcern]="elementOfConcern"-->
      <!--          ></app-element-of-concern>-->
      <!--        </div>-->
      <!--      }-->
    }

    <div class="margin-top-40">
      <mat-divider></mat-divider>
    </div>
  </div>
} @else {
  <div class="container">
    <mat-toolbar class="row product-name-navbar">
      <span class="bold-600 medium-font">{{
        productChemistry?.articleName
      }}</span>
    </mat-toolbar>
    <app-chemistry-nav
      (selectedProductChange)="setProductChemistry($event)"
    ></app-chemistry-nav>
    <app-chemistry-info
      [chemistry]="productChemistry"
      [isProduct]="true"
      [isMobileView]="isMobileView"
    ></app-chemistry-info>

    @if (productChemistry?.substances && productChemistry?.substances?.length) {
      <div class="margin-top-40">
        <mat-divider></mat-divider>
      </div>
      <!--      @for (-->
      <!--        elementOfConcern of productChemistry!.substances;-->
      <!--        track elementOfConcern-->
      <!--      ) {-->
      <!--        <div class="margin-top-40">-->
      <!--          <app-element-of-concern-->
      <!--            [elementOfConcern]="elementOfConcern"-->
      <!--          ></app-element-of-concern>-->
      <!--        </div>-->
      <!--      }-->
    }

    <div class="margin-top-40 margin-sides-5">
      <mat-divider></mat-divider>
    </div>
  </div>
}
